<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="main-title" style="margin-top: 20px">
          {{
            menu_mark == "PcInvitation"
              ? "药交会邀请函"
              : menu_mark == "NhneInvitation"
              ? "NHNE邀请函"
              : "NHi邀请函"
          }}
        </div>
        <div class="invitation-wrap">
          <div class="invitation-tips">
            <p>
              1、上传图片需注意空出文字和二维码位置，且上传的图片需符合法律法规要求；
            </p>
            <p>2、自定义的邀请函图片请自行下载保存。</p>
          </div>
          <div class="invitation-poster">
            <div class="poster-main">
              <div
                class="poster-left"
                v-if="posterList.length > 0"
                id="posterHtml"
              >
                <el-image
                  class="img-icon"
                  v-if="imgUrl"
                  :src="imgUrl"
                ></el-image>
                <template v-if="posterList[currentIndex].type != 4">
                  <el-image
                    v-if="posterList[currentIndex].type == 1"
                    class="img-bottom"
                    :src="imgbUrl"
                  ></el-image>
                  <el-image
                    v-else-if="posterList[currentIndex].type == 2"
                    class="img-bottom"
                    :src="imgbUrl2"
                  ></el-image>
                  <el-image
                    v-else
                    class="img-bottom"
                    :src="imgbUrl1"
                  ></el-image>
                  <div
                    class="booth"
                    :class="{
                      bg1: posterList[currentIndex].type == 1,
                      bg2: posterList[currentIndex].type == 2,
                      boothbottom: userdata.name_cn.length > 10,
                    }"
                  >
                    {{ userdata.hallNo }}{{ userdata.boothNo }}
                  </div>
                  <div
                    class="name"
                    :class="{
                      bg1: posterList[currentIndex].type == 1,
                      bg2: posterList[currentIndex].type == 2,
                    }"
                  >
                    {{ userdata.name_cn }}
                  </div>
                  <div class="wx-code">
                    <img
                      v-if="wxCodeUrl"
                      :src="wxCodeUrl"
                      alt=""
                      class="code-img"
                    />
                    <p>扫码进入</p>
                    <p>企业店铺</p>
                  </div>
                </template>
                <template v-else>
                  <img
                    v-if="wxCodeUrl"
                    :src="wxCodeUrl"
                    alt=""
                    class="wx-codeimg"
                  />
                  <!-- 2024.10.12 邀请函新增展位号／logo/企业名称字段 dxm -->
                  <div class="poster-type">
                    <div class="poster-text">展位号</div>
                    <div class="poster-text">{{ userdata.hallNo }}{{ userdata.boothNo }}</div>
                    <div class="poster-logo" :class="{ posterb: userdata.name_cn.length > 9 }">
                      <img
                        v-if="userdata.logo"
                        :src="$imgOssUrl + userdata.logo"
                        alt=""
                        class="logo-img"
                      />
                    </div>
                    <div class="poster-name">{{ userdata.name_cn }}</div>
                  </div>
                </template>
                <qr-code
                  v-if="codeUrlLink"
                  :text="codeUrlLink"
                  :index="0"
                  class="code-icon"
                ></qr-code>
              </div>
              <div class="poster-right">
                <p>选择背景：</p>
                <div class="poster-wrap">
                  <div
                    class="image"
                    :class="{ active: currentIndex == index }"
                    v-for="(item, index) in posterList"
                    :key="index"
                    @click="changeBg(index)"
                  >
                    <el-image :src="$imgOssUrl + item.image"></el-image>
                    <img
                      v-if="item.company_long_id != '0000'"
                      class="close-icon"
                      src="../assets/close_icon.png"
                      alt=""
                      @click.stop="deleteImg(index, item.id)"
                    />
                  </div>
                  <el-upload
                    :action="$Url"
                    list-type="picture-card"
                    :headers="headers"
                    :multiple="false"
                    :before-upload="beforeUpload"
                    :on-success="handlePosterSuccess"
                    :on-error="handlePosterError"
                    :show-file-list="false"
                  >
                    <div
                      style="
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        padding-top: 45px;
                      "
                    >
                      <i class="el-icon-plus"></i>
                      <span
                        style="
                          width: 100%;
                          height: 20px;
                          line-height: 20px;
                          font-size: 12px;
                          color: #666;
                          margin-top: 20px;
                        "
                        >建议尺寸:437*777</span
                      >
                    </div>
                  </el-upload>
                </div>
                <div class="poster-btn" @click="createPoster">生成邀请函</div>
              </div>
            </div>
            <div class="invitation-title" v-if="makeImgs.length > 0">
              已制作的邀请函
            </div>
            <div class="diy-item">
              <div
                class="down-img item"
                :id="'posterHtml_' + index"
                v-for="(item, index) in makeImgs"
                :key="index"
              >
                <el-image
                  class="img-icon"
                  v-if="item.image"
                  :src="$imgOssUrl + item.image"
                ></el-image>
                <div class="item-mask">
                  <div class="item-btn" @click="downPoster(index)">下载</div>
                  <div
                    class="item-btn del-btn"
                    @click="delMakeImg(index, item.id)"
                  >
                    删除
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  skipOrReadStep,
  invitationBgLists,
  invitationBgAdd,
  invitationBgDelete,
  invitationLists,
  invitationAdd,
  invitationDelete,
  registrationUrl,
  upBase64cCode,
  getUnlimited,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import html2canvas from "html2canvas";
import QrCode from "../components/qrcode.vue";
export default {
  components: { top, navMenu, QrCode },
  name: "invitation",
  data() {
    return {
      loading: false,
      active: 2,
      detail: {},
      headers: {},
      userdata: {},
      posterList: [], //邀请函背景列表
      makePosters: [], //已制作的邀请函列表
      currentIndex: 0,
      imgUrl: "",
      imgbUrl: require("../assets/poster_bg.png"),
      imgbUrl1: require("../assets/poster_bg1.png"),
      imgbUrl2: require("../assets/poster_bg2.png"),
      makeImgs: [], //已制作的邀请函
      codeUrlLink: "", //邀请函二维码链接
      menu_mark: "",
      wxCodeUrl: "", //微信小程序码
    };
  },
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {
    getData() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "conference" && item.id == 22;
      });
      this.detail = stepMenuList[index];
      this.active = index;
      let token = localStorage.getItem("token");
      this.headers = {
        token: token,
      };
      this.userdata = JSON.parse(localStorage.getItem("userdata"));
      this.menu_mark = this.$route.query.mark;
      //获取邀请函二维码链接
      this.getRegistrationUrl();
      //获取小程序码
      this.getUnlimitedCode();
      //24.8.20 获取邀请函背景 dxm
      this.getBgList();
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    //获取邀请函二维码链接
    getRegistrationUrl() {
      let data = this.$qs.stringify({
        mark: this.menu_mark,
      });
      registrationUrl(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.codeUrlLink = data.url;
            //获取已制作邀请函列表
            this.getMakeBackground();
          }
        })
        .catch((err) => {});
    },
    //获取邀请函背景
    getBgList() {
      this.loading = true;
      invitationBgLists(this.menu_mark)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            let imgs = data.lists;
            imgs.forEach((item) => {
              if (item.image.substring(0, 1) == "/") {
                item.image = item.image.substring(1);
              }
            });
            this.posterList = imgs;
            //背景默认第一个
            this.imgUrl = this.$imgOssUrl + this.posterList[0].image;
          }
        })
        .catch((err) => {});
    },
    //切换选中海报
    changeBg(index) {
      //当前选中海报背景
      this.currentIndex = index;
      this.imgUrl = this.$imgOssUrl + this.posterList[index].image;
    },
    //获取邀请函列表
    getMakeBackground() {
      invitationLists(this.menu_mark)
        .then((res) => {
          if (res.data.code == 1) {
            let data = res.data.data.lists;
            this.makeImgs = data;
          }
        })
        .catch((err) => {});
    },
    //24.9.29 获取小程序二维码 dxm
    getUnlimitedCode() {
      let data = this.$qs.stringify({
        page: "pages/show/qydetail/qydetail",
      });
      getUnlimited(data)
        .then((res) => {
          let data = res.data;
          this.wxCodeUrl = window.URL.createObjectURL(
            new Blob([data], { type: "image/jpeg" })
          );
        })
        .catch((err) => {});
    },
    //生成邀请函
    createPoster() {
      let that = this;
      that.$alert(`确定要生成邀请函吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            that.loading = true;
            //图片转成base64
            let image = that.imgUrl;
            that.convertImageToBase64(image, that.base64CallBack);
            let posterDOM = document.getElementById("posterHtml");
            html2canvas(posterDOM, {
              width: posterDOM.offsetWidth,
              height: posterDOM.offsetHeight,
              //按比例增加分辨率
              scale: window.devicePixelRatio * 4, // 设备像素比
              useCORS: true, //（图片跨域相关）
              allowTaint: true, //允许跨域（图片跨域相关）
              logging: false,
              letterRendering: true,
            }).then(function (canvas) {
              let posterImgURL = canvas.toDataURL();
              //console.log(posterImgURL, '=====posterImgURL')
              that.getupBase64cCode(posterImgURL);
            });
          }
        },
      });
    },
    getupBase64cCode(dataURL) {
      let data = { base64_image: dataURL };
      upBase64cCode(this.$qs.stringify(data))
        .then((res) => {
          if (res.data.code == 1) {
            console.log("保存成功");
            this.addPoster(res.data.data.url);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addPoster(posterImgURL) {
      let data = this.$qs.stringify({
        image: posterImgURL,
        menu_mark: this.menu_mark,
      });
      invitationAdd(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.loading = false;
            this.getMakeBackground();
          }
        })
        .catch((err) => {});
    },
    // 下载海报
    downPoster(index) {
      let that = this;
      that.loading = true;
      let image = that.$imgOssUrl + that.makeImgs[index].image;
      that.convertImageToBase64(image, that.base64CallBack, index);
      let id = "posterHtml_" + index;
      let posterDOM = document.getElementById(id);
      html2canvas(posterDOM, {
        width: posterDOM.offsetWidth,
        height: posterDOM.offsetHeight,
        //按比例增加分辨率
        scale: window.devicePixelRatio * 4, // 设备像素比
        useCORS: true, //（图片跨域相关）
        allowTaint: true, //允许跨域（图片跨域相关）
        logging: false,
        letterRendering: true,
      })
        .then(function (canvas) {
          let posterImgURL = canvas.toDataURL("image/png");
          let a = document.createElement("a");
          a.download = "邀请函";
          a.href = posterImgURL;
          a.dispatchEvent(new MouseEvent("click"));
          that.loading = false;
        })
        .catch((err) => {
          console.log(err, "err");
        });
      // const link = document.createElement("a");
      // link.href = image;
      // link.target = "_blank";
      // link.download = "邀请函.png";
      // link.click();
      //that.loading = false;
    },
    //下载邀请函时，图片转base64
    convertImageToBase64(imgUrl, callback) {
      const image = new Image();
      // image.setAttribute("crossOrigin", "Anonymous");
      image.crossOrigin = "Anonymous"; // 设置跨域属性
      image.src = imgUrl;
      console.log(image.src, "=====image.src");
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL();
        callback && callback(dataUrl);
      };
      image.onerror = (error) => {
        console.error("图加载失败", error);
      };
    },
    base64CallBack(base64) {
      this.imgUrl = base64;
    },
    //删除背景图
    deleteImg(index, id) {
      this.$alert(`确定要删除当前背景图吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            invitationBgDelete({ id })
              .then((res) => {
                if (res.data.code == 1) {
                  this.posterList.splice(index, 1);
                  this.currentIndex = 0;
                  this.imgUrl = this.$imgOssUrl + this.posterList[0].image;
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    //删除已制作的邀请函
    delMakeImg(index, id) {
      this.$alert(`确定要删除邀请函吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            invitationDelete({ id })
              .then((res) => {
                if (res.data.code == 1) {
                  this.makeImgs.splice(index, 1);
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    //限制用户上传的图片大小
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 7;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 7MB!");
      }
      return isLt2M;
    },
    //海报上传成功
    handlePosterSuccess(resData, file, fileList) {
      invitationBgAdd({
        image: resData.data.url,
        type:
          this.menu_mark == "PcInvitation"
            ? "1"
            : this.menu_mark == "CphiInvitation"
            ? "2"
            : "9",
        menu_mark: this.menu_mark,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.getBgList();
          }
        })
        .catch((err) => {});
    },
    // 海报上传失败
    handlePosterError(err, file, fileList) {
      this.$message.error(err.message);
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        if (this.detail.action == 1 || this.detail.action == 4) {
          this.toPath();
        } else {
          this.$message.warning("请完善信息!");
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.toPath();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin-bottom: 0;
  .invitation-wrap {
    padding: 20px;
    margin-top: 20px;
    border-radius: 10px;
    background: #fff;
    min-height: 550px;
    .invitation-tips {
      font-size: 13px;
      color: #666666;
      line-height: 18px;
    }
    .invitation-poster {
      font-size: 14px;
      color: #2c2c2e;
      line-height: 20px;
      .poster-main {
        display: flex;
        margin-top: 30px;
        .poster-left {
          width: 175px;
          height: 311px;
          position: relative;
          margin-right: 50px;
          .img-icon {
            width: 100%;
            height: 100%;
          }
          .img-bottom {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
          }
          .name {
            position: absolute;
            // bottom: 93px;
            top: 190px;
            left: 0;
            width: 67%;
            color: #fff;
            font-size: 12px;
            font-weight: 500;
            padding: 3px 10px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            min-height: 25px;
            line-height: 15px;
            background: rgba(0, 0, 0, 0.15);
          }
          .booth {
            position: absolute;
            bottom: 124px;
            left: 0;
            width: 67%;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            padding: 3px 10px 4px;
            box-sizing: border-box;
            background: rgba(0, 0, 0, 0.15);
          }
          .boothbottom {
            bottom: 140px;
          }
          .bg1 {
            background: rgba(229, 22, 38, 0.8);
          }
          .bg2 {
            background: rgba(122, 180, 44, 0.9);
          }
          .code-icon {
            position: absolute;
            z-index: 9;
            bottom: 23px;
            right: 8px;
            width: 42px;
            height: 42px;
          }
          .wx-codeimg {
            position: absolute;
            z-index: 9;
            bottom: 23px;
            right: 59px;
            width: 42px;
            height: 42px;
          }
          .wx-code {
            position: absolute;
            bottom: 93px;
            right: 5px;
            width: 48px;
            color: #fff;
            font-size: 12px;
            text-align: center;
            .code-img {
              width: 42px;
              height: 42px;
              position: relative;
              top: 4px;
            }
            p {
              margin: 0;
              line-height: 7px;
              font-weight: 300;
              transform: scale(0.4);
            }
          }
          .poster-type {
            position: absolute;
            top: 104px;
            left: 24px;
            width: 127px;
            padding: 8px 0 0;
            text-align: center;
            .poster-text {
              font-size: 12px;
              color: #fc6b00;
              font-weight: 500;
              line-height: 16px;
            }
            .poster-logo {
              width: 50%;
              height: 30px;
              margin: 4px auto 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              .logo-img {
                max-width: 100%;
                max-height: 100%;
              }
            }
            .posterb{
              margin-bottom: 2px;
            }
            .poster-name {
              color: #000;
              width: 90%;
              margin: 0 auto;
              font-size: 12px;
              font-weight: 500;
              line-height: 13px;
              transform: scale(0.8);
            }
          }
        }
      }
      p {
        margin-bottom: 5px;
      }
      .poster-wrap {
        display: flex;
        flex-wrap: wrap;
        .image {
          width: 86px;
          height: 150px;
          margin-right: 12px;
          margin-bottom: 12px;
          position: relative;
          cursor: pointer;
          border: 2px solid transparent;
          /deep/ .el-image {
            width: 86px;
            height: 150px;
            .el-image__inner {
              width: 100%;
              height: 100%;
            }
          }
          .close-icon {
            position: absolute;
            top: 3px;
            right: 3px;
            width: 20px;
            height: 20px;
          }
        }
        .active {
          border-color: #1677ff;
        }
      }
      .poster-btn {
        width: 148px;
        height: 38px;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
        line-height: 38px;
        margin-top: 20px;
        cursor: pointer;
        background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
        border-radius: 6px;
      }
      .invitation-title {
        font-weight: 500;
        font-size: 16px;
        color: #022a48;
        line-height: 22px;
        margin-top: 50px;
        span {
          color: #888;
          font-size: 16px;
          font-weight: 400;
        }
        .rank {
          color: #fff;
          font-size: 13px;
          padding: 5px 10px;
          border-radius: 5px;
          background: #fc933f;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .diy-item {
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 175px;
          height: 311px;
          margin-top: 12px;
          margin-right: 12px;
          position: relative;
          .img-icon {
            width: 100%;
            height: 100%;
          }
          .img-bottom {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
          }
          .name {
            position: absolute;
            bottom: 85px;
            left: 0;
            width: 90%;
            color: #fff;
            font-size: 12px;
            font-weight: 500;
            padding: 5px 10px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            min-height: 30px;
            background: rgba(0, 0, 0, 0.15);
          }
          .booth {
            position: absolute;
            bottom: 120px;
            left: 0;
            width: 90%;
            color: #fff;
            font-size: 15px;
            font-weight: 500;
            padding: 0 10px;
            box-sizing: border-box;
            line-height: 33px;
            height: 33px;
            background: rgba(0, 0, 0, 0.15);
          }
          .boothbottom {
            bottom: 140px;
          }
          .bg1 {
            background: rgba(229, 22, 38, 0.8);
          }
          .bg2 {
            background: rgba(122, 180, 44, 0.9);
          }
          .code-icon {
            position: absolute;
            z-index: 9;
            bottom: 35px;
            right: 12px;
            width: 40px;
            height: 40px;
          }
          &:hover .item-mask {
            opacity: 1;
          }
          .item-mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 99;
            opacity: 0;
            padding: 80px 0 0;
            transition: all 0.3s;
            box-sizing: border-box;
            background: rgba($color: #000, $alpha: 0.4);
            .item-btn {
              width: 110px;
              height: 40px;
              color: #fff;
              font-size: 14px;
              line-height: 40px;
              text-align: center;
              background: #1677ff;
              border-radius: 5px;
              margin: 30px auto 0;
              display: block;
              cursor: pointer;
              &:hover {
                opacity: 0.95;
              }
            }
            .del-btn {
              background: #ff4d4f;
            }
          }
        }
      }
      .viewer-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        .viewer-item {
          width: 360px;
          height: 111px;
          padding: 15px;
          color: #999;
          font-size: 12px;
          line-height: 17px;
          border-radius: 6px;
          margin: 0 20px 20px 0;
          background: #f3f5fb;
          box-sizing: border-box;
          .viewer-title {
            font-weight: 500;
            font-size: 14px;
            color: #2c2c2e;
            line-height: 20px;
            margin: 16px 0 6px;
            span {
              font-size: 13px;
              font-weight: 400;
              color: #2c2c2e;
              line-height: 18px;
              padding-left: 26px;
            }
          }
          .viewer-text {
            color: #000;
          }
        }
      }
    }
  }
}
.rank-list {
  border-top: 1px solid #eee;
  .rank-number {
    width: 20px;
    height: 20px;
    font-size: 14px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    background: #eab572;
  }
  .rank-defalut {
    color: #666;
    background: transparent;
  }
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border-color: #f6f7f9;
}
/deep/ .el-upload--picture-card {
  width: 152px;
  height: 152px;
  line-height: 152px;
}
/deep/ .el-dialog {
  margin-top: 0 !important;
  border-radius: 10px;
}
/deep/ .el-dialog__body {
  padding: 10px 25px 25px;
}
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-table::before {
  height: 0;
}
.conf-btn {
  position: absolute;
  bottom: 65px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 10px 15px 130px 15px;
  }
  .content .invitation-wrap .invitation-poster .poster-main {
    flex-wrap: wrap-reverse;
  }
  .content .invitation-wrap .invitation-poster .poster-main .poster-left {
    margin-top: 20px;
  }
}
</style>